import React, { useEffect, useState } from 'react';
import { Routes, useNavigate, useLocation } from "react-router-dom";
import routes from '../../libs/routes';
import images from "../../libs/images";
import * as API from "../../libs/service";
import { useDispatch, useSelector } from 'react-redux';
import { loadingStart, loadingEnd } from "../../redux/loadingSlice";
import { open, close } from "../../redux/popupSlice";
import Popup01 from "../../pages/popup/Popup01";
import { ToastContainer, toast, Slide } from 'react-toastify';
import { BrowserView, MobileView, isBrowser } from 'react-device-detect';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/autoplay';
import 'react-toastify/dist/ReactToastify.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

// ==================== 상수 정의 ====================
const HEADER_TEXT = {
  title: {
    ko: '상상을 실현하는 메타버스 크리에이팅',
    en: 'Build the Metaverse with Your Imagination'
  },
  subTitle: {
    ko: '매력적인 캐릭터와 월드를 만들고, 새로운 이야기를 들려주세요',
    en: 'Create stunning worlds and characters, and tell stories that inspire.'
  },
  startButton: {
    ko: '무료로 써보기',
    en: 'Try for Free'
  },
  inquiryButton: {
    ko: '문의하기',
    en: 'Contact Us'
  }
};

const CONTENT_ITEMS = [
  {
    title: { ko: 'VRChat & ZEPETO', en: 'VRChat & ZEPETO' },
    bigTitle: { ko: '인기 메타버스 플랫폼과 완벽 호환', en: 'Seamless Integration' },
    body: {
      ko: 'UModeler X는 VRChat과 ZEPETO 콘텐츠 제작에 유용한 에셋으로 선정되어, 다양한 가상 세계에서 활용할 수 있습니다. 배경부터 캐릭터까지 손쉽게 제작할 수 있으며, 이를 통해 VR 메타버스 환경에 생동감을 더하고 몰입도를 높일 수 있습니다.',
      en: 'UModeler X is recognized as a valuable asset for creating VRChat and ZEPETO content, enabling seamless content development across diverse virtual worlds. Effortlessly craft everything from immersive backgrounds to unique characters, enhancing realism and engagement in VR metaverse experiences.'
    },
    image: require("../../assets/vr_01.webp"),
    reverse: false
  },
  {
    title: { ko: '월드 제작', en: 'World Creation' },
    bigTitle: { ko: '누구나 방문하고 싶은 메타버스 월드 제작', en: 'Design your Worlds' },
    body: {
      ko: '워킹 시뮬레이션부터 상호작용이 가능한 게임 월드까지,UModeler X의 강력한 기능과 다양한 에셋을 활용하여 자신만의 독창적인 공간을 제작할 수 있습니다. VRChat과 ZEPETO에서 개성 넘치는 월드를 만들어, 몰입감 있는 가상 환경을 직접 구축해 보세요!',
      en: 'From interactive game worlds to immersive simulations,  UModeler X gives you the power to create truly unique spaces.  With advanced tools and diverse assets, you can bring your vision  to life in VRChat and ZEPETO—building rich, engaging environments  that captivate and inspire.'
    },
    image: require("../../assets/vr_02.webp"),
    reverse: true
  },
  {
    title: { ko: '캐릭터 모델링', en: 'Character Modeling' },
    bigTitle: { ko: '생동감 넘치는 나만의 아바타 제작', en: 'Create Lifelike Avatars' },
    body: {
      ko: 'UModeler X가 지원하는 리깅 모드와 브렌드 쉐입 모드를 활용하면 자연스러운 동작과 표정 변화를 가진 캐릭터를 손쉽게 제작할 수 있습니다. 이를 통해 버튜버, VR 아바타 등 다양한 형태의 생동감 넘치는 캐릭터를 창조할 수 있으며, 몰입감 있는 가상 세계에서 더욱 현실적인 표현이 가능합니다.',
      en: 'UModeler X empowers you to craft dynamic avatars with fluid  movements and expressive facial animations—effortlessly.  With advanced rigging and blend shape tools,  you can design characters that feel alive, whether for VTubing, VR, or interactive digital experiences. Step into a more immersive virtual world with avatars that truly express who you are.'
    },
    image: require("../../assets/vr_03.webp"),
    reverse: false
  },
  {
    title: { ko: '생성형 AI', en: 'Gen AI Utilization' },
    bigTitle: { ko: '생성형 AI와 함께하는 3D 모델링', en: 'Boost Your Workflow with AI' },
    body: {
      ko: '생성형 AI로 제작된 3D 모델을 실시간으로 UModeler X에서 편집하여 더욱 빠르고 효율적인 작업이 가능합니다. AI 기반 모델을 직접 수정하고 세부적으로 조정할 수 있어 원하는 형태로 정교하게 다듬을 수 있으며, 이를 통해 작업 시간을 단축하고 창의적인 디자인을 자유롭게 구현할 수 있습니다.',
      en: 'Leverage UModeler X to edit AI-generated 3D models instantly,  refining them with precision and ease. Customize every detail  to match your vision, accelerating your workflow while  unlocking boundless creative possibilities.'
    },
    image: require("../../assets/vr_04.webp"),
    reverse: true
  },
  {
    title: { ko: 'SDK', en: 'SDK' },
    bigTitle: { ko: '유모델러로 메타버스를 강화', en: 'Enhance the Metaverse with Us' },
    body: {
      ko: '메타버스 SDK에 UModeler X를 탑재하여 더욱 직관적이고 강력한 모델링 환경을 제공함으로써 더 많은 사용자를 유치할 수 있습니다. 이를 통해 창작자들은 쉽고 빠르게 콘텐츠를 제작할 수 있으며, 메타버스의 가능성을 확장하고 더욱 몰입감 있는 가상 세계를 구축할 수 있습니다.',
      en: 'Integrate UModeler X into your Metaverse SDK to provide a  more intuitive and powerful modeling experience, attracting more users.  Empower creators to produce content quickly and effortlessly  while expanding the possibilities of the Metaverse.  Build a more immersive virtual world with ease.'
    },
    image: require("../../assets/vr_05.webp"),
    reverse: false
  }
];

const PARTNER_TEXT = {
  title: {
    ko: '투자사 및 파트너',
    en: 'Investors and Partners'
  }
};

const BANNER_TEXT = {
  title: {
    ko: '나만의 메타버스 세상을 만들기 위한 가장 쉬운 방법',
    en: 'Your Metaverse, Made Simple'
  },
  inquiryButton: {
    ko: '문의하기',
    en: 'Contact Us'
  },
  startButton: {
    ko: '무료로 써보기',
    en: 'Try for Free'
  }
};

// ==================== 컴포넌트 ====================
export default function Metaverse() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const lang = useSelector(state => state.langReducer.lang);
  const [supBtnHover, setSupBtnHover] = useState(false);
  const partner_top_sample = 6;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="main_back">
        <div className="main_part padding">
          <div className="header_page_title_box">
            <p className="title">
              {lang === 0 ? HEADER_TEXT.title.ko : HEADER_TEXT.title.en}
            </p>
            <span className="sub_title">
              {lang === 0 ? HEADER_TEXT.subTitle.ko : HEADER_TEXT.subTitle.en}
            </span>
            <div className="btn_box">
              <button
                type="button"
                className={`start ${lang === 1 ? 'eng' : ''}`}
                style={{width: 280,}}
                onClick={() => {
                  navigate(routes.Price);
              }}
              >
                {lang === 0 ? HEADER_TEXT.startButton.ko : HEADER_TEXT.startButton.en}
              </button>
              <button
                type="button"
                className={`inquiry ${lang === 1 ? 'eng' : ''}`}
                style={{width: 280,}}
                onClick={() => {
                  navigate(routes.Inquiry);
                }}
              >
                {lang === 0 ? HEADER_TEXT.inquiryButton.ko : HEADER_TEXT.inquiryButton.en}
              </button>
            </div>
          </div>
          <div className="header_page_content_box">
            {CONTENT_ITEMS.map((item, index) => {
              const contentClass = index % 2 === 1 ? "content" : "content";
              return (
                <div className={contentClass} key={index}>
                  {item.reverse ? (
                    <>
                      <div className="title_box">
                        <div className="top_title">
                          {lang === 0 ? item.title.ko : item.title.en}
                        </div>
                        <p>
                          {lang === 0 ? item.bigTitle.ko : item.bigTitle.en}
                        </p>
                        <span style={{ whiteSpace: 'pre-line' }}>
                          {lang === 0 ? item.body.ko : item.body.en}
                        </span>
                      </div>
                      <div className="img_box_169" style={{ flex: 1 }}>
                        <img src={item.image} alt={`content-${index}`} />
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="img_box_169" style={{ flex: 1 }}>
                        <img src={item.image} alt={`content-${index}`} />
                      </div>
                      <div className="title_box">
                        <div className="top_title">
                          {lang === 0 ? item.title.ko : item.title.en}
                        </div>
                        <p>
                          {lang === 0 ? item.bigTitle.ko : item.bigTitle.en}
                        </p>
                        <span style={{ whiteSpace: 'pre-line' }}>
                          {lang === 0 ? item.body.ko : item.body.en}
                        </span>
                      </div>
                    </>
                  )}
                </div>
              );
            })}
          </div>
        </div>
        <div className="page_start_banner">
          <div className="content">
            <p className="title">
              {lang === 0 ? BANNER_TEXT.title.ko : BANNER_TEXT.title.en}
            </p>
            <div className="btn_box">
              <button
                type="button"
                className={`start ${lang === 1 ? 'eng' : ''}`}
                onClick={() => {
                  navigate(routes.Price);
              }}
                
              >
                {lang === 0 ? BANNER_TEXT.startButton.ko : BANNER_TEXT.startButton.en}
              </button>
              <button
                type="button"
                className={`inquiry ${lang === 1 ? 'eng' : ''}`}
                onClick={() => {
                  navigate(routes.Inquiry);
                }}
              >
                {lang === 0 ? BANNER_TEXT.inquiryButton.ko : BANNER_TEXT.inquiryButton.en}
              </button>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer
        position="bottom-center"
        transition={Slide}
        limit={1}
        closeButton={false}
        autoClose={1000}
        style={{ width: isBrowser ? 400 : '100%', marginBottom: isBrowser ? 60 : 70 }}
        hideProgressBar
      />
    </>
  );
}